import { Component, OnDestroy } from '@angular/core';
import { SearchParams } from '../../../../../shared/search/models/search-params.model';
import { SearchService } from '../../../../../shared/search/search.service';
import { SearchStatus } from '../../../../../shared/search/models/search-status.model';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { Subscription } from 'rxjs/Subscription';
import { SearchEvent } from '../../../../../shared/search/models/search-event';
import { ModalService } from '../../../../../shared/services/modal.service';

@Component({
  selector: 'lfwms-show-empty-location-lookup-popup',
  templateUrl: './show-empty-location-lookup-popup.component.html',
  styleUrls: ['./show-empty-location-lookup-popup.component.css']
})
export class ShowEmptyLocationLookupComponent implements OnDestroy {

  private lookupParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupService: SearchService;
  public showLookup: boolean = false;
  public lookupAlertService: AlertService;
  public title: string;
  private eventSubscription: Subscription;
  public pageRows: Array<any>;

  constructor(public modalService: ModalService,
      protected resourceService: ResourceService,
      protected sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
  }

  public initializeComponents(lookupParams: any, lookupStatus: any, searchCriteria: any, dataEditor?: any) {
    this.lookupParams = lookupParams;
    this.lookupParams.tableEditor = dataEditor;
    this.lookupService = this.sharedServiceRegistry.createSearchService(lookupParams, lookupStatus);
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupService.setSearchCriteria(searchCriteria);
    this.lookupService.performSearch();
    this.eventSubscription = this.lookupService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.pageRows = this.lookupService.getPagedData().pageRows;
      });
  }

  public ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/abc-control/abc-moves/popup/show-empty-location-lookup-popup.component.ts